import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Elements } from '@stripe/react-stripe-js';
import InjectedCheckoutForm from './CheckoutForm';


function mapStateToProps(state) {
    return {

    };
}

class Stripe extends Component {
    constructor() {
        super();
    }

    render() {
        var props = this.props;
        if (this.props.stripePromise) {
            return (
                <Elements stripe={this.props.stripePromise}>
                    <InjectedCheckoutForm {...props} />
                </Elements>
            );
        } else return null;
    }
}

export default connect(
    mapStateToProps,
)(Stripe);
